import { useState, useEffect } from 'react';

export function useCountdown(targetDate) {
  const calculer = () => {
    if (!targetDate) return { jours: 0, heures: 0, minutes: 0, secondes: 0, fini: true };
    const diff = new Date(targetDate) - new Date();
    if (diff <= 0) return { jours: 0, heures: 0, minutes: 0, secondes: 0, fini: true };
    return {
      jours:    Math.floor(diff / 86400000),
      heures:   Math.floor((diff % 86400000) / 3600000),
      minutes:  Math.floor((diff % 3600000) / 60000),
      secondes: Math.floor((diff % 60000) / 1000),
      fini: false,
    };
  };

  const [temps, setTemps] = useState(calculer);

  useEffect(() => {
    if (!targetDate) return;
    const interval = setInterval(() => setTemps(calculer()), 1000);
    return () => clearInterval(interval);
  }, [targetDate]);

  return temps;
}
